import { useEffect, useState } from "react";
import logo from "../assets/logo/pms-logo.png";
import { useNavigate, useLocation } from "react-router-dom";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  const goHome = () => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("hero")?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById("hero")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleNav = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300
        ${scrolled ? "bg-white shadow-md" : "bg-brand-green"}
      `}
    >
      {/* Reduced py-4 → py-2 to shrink navbar height */}
      <div className="max-w-7xl mx-auto px-6 py-2 flex justify-between items-center">

        {/* BRAND AREA — fixed height container, both logos absolutely stacked */}
        <div
          onClick={goHome}
          className="cursor-pointer relative h-10 flex items-center"
          style={{ minWidth: "160px" }}
        >
          {/* TEXT LOGO — shown when NOT scrolled */}
          <span
            className={`absolute inset-0 flex items-center transition-all duration-300
              font-bold tracking-wide whitespace-nowrap
              ${scrolled ? "opacity-0 pointer-events-none translate-y-1" : "opacity-100 translate-y-0"}
              text-white text-xl leading-none
            `}
            style={{ fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif", letterSpacing: "0.04em" }}
          >
            PMS<span className="font-light ml-1">Packages</span>
          </span>

          {/* IMAGE LOGO — shown when scrolled */}
          <img
            src={logo}
            alt="PMS Packages"
            className={`absolute inset-0 h-10 w-auto transition-all duration-300 object-contain object-left
              ${scrolled ? "opacity-100 translate-y-0" : "opacity-0 pointer-events-none translate-y-1"}
            `}
          />
        </div>

        {/* NAV LINKS */}
        <ul
          className={`hidden md:flex gap-8 text-sm uppercase tracking-wider font-medium
            ${scrolled ? "text-dark" : "text-white"}
          `}
        >
          <li onClick={() => handleNav("about")} className="cursor-pointer hover:text-brand-blue transition-colors duration-150">About</li>
          <li onClick={() => handleNav("products")} className="cursor-pointer hover:text-brand-blue transition-colors duration-150">Products</li>
          <li onClick={() => handleNav("process")} className="cursor-pointer hover:text-brand-blue transition-colors duration-150">Process</li>
          <li onClick={() => handleNav("certifications")} className="cursor-pointer hover:text-brand-blue transition-colors duration-150">Certifications</li>
          <li onClick={() => navigate("/contact")} className="cursor-pointer hover:text-brand-blue transition-colors duration-150">Contact</li>
        </ul>

      </div>
    </nav>
  );
}